const icon = require('vue-svgicon');
icon.register({
    'chevron-left': {
        width: 28,
        height: 28,
        viewBox: '0 0 28 28',
        data: `<path pid="0" d="M20.464 3.243L8.714 14l11.749 10.755a.988.988 0 010 1.399.992.992 0 01-1.4 0L6.669 14.806c-.05-.034-.118-.021-.163-.066a.98.98 0 01-.283-.737.978.978 0 01.282-.744c.047-.046.116-.034.169-.07l12.39-11.345a.994.994 0 011.4 0 .988.988 0 010 1.399z"/>`,
    },
});
